import { render, staticRenderFns } from "./RflmChildrenSurvey.vue?vue&type=template&id=d82527b8"
import script from "./RflmChildrenSurvey.vue?vue&type=script&lang=ts"
export * from "./RflmChildrenSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports